import { RestSchemas } from '@/contexts/QueryProvider'
import { ActivityLogV2Props } from '../ActivityLogV2'
import { NextStepHeading } from './NextStepHeading'

type LogItem = RestSchemas['Messages.DataAssets.TDataAssetActivity']

export function StartAction({ entityId, dataAssetId, lastActivity }: ActivityLogV2Props & { lastActivity: LogItem }) {
  return (
    <>
      <NextStepHeading>Process data</NextStepHeading>
      <p>Process data within the app to generate a new result.</p>
    </>
  )
}
